import React from 'react'
import { useNavigate } from 'react-router-dom';

const UseNavigateAssistant = ({ component, route }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(route)
    }
    const ComponentWithProps = React.cloneElement(component, { onClick: handleClick, onTouchTap: handleClick });
    return (<React.Fragment>
        {ComponentWithProps}
    </React.Fragment>

    );

}

export default UseNavigateAssistant